/**
 * Bundle Builder - Gift Set Builder Cart Integration
 *
 * This script extends Dawn's default cart behavior to automatically add
 * bundle items when the base product is added to cart.
 *
 * Flow:
 * 1. Customer clicks "Add to Cart"
 * 2. Dawn adds base product (via product-form.js)
 * 3. Dawn publishes cartUpdate event
 * 4. This script detects the event and adds bundle items with sections
 * 5. Cart drawer opens with all items visible
 */

(function () {
  "use strict";

  // Flag to track if we're currently processing bundle items
  let isProcessingBundle = false;
  let pendingCartData = null;

  // Wait for DOM to be fully loaded
  function initBundleBuilder() {
    console.log("Bundle Builder: Initializing...");

    // Check if pubsub is available
    if (typeof subscribe === "undefined") {
      console.error(
        "Bundle Builder: subscribe() function not found. Pubsub may not be loaded yet.",
      );
      return;
    }

    if (typeof PUB_SUB_EVENTS === "undefined") {
      console.error(
        "Bundle Builder: PUB_SUB_EVENTS constant not found. Constants may not be loaded yet.",
      );
      return;
    }

    console.log(
      "Bundle Builder: Pubsub system available, subscribing to cart updates...",
    );

    const cartDrawer = document.querySelector("cart-drawer");

    // Store the original renderContents method
    const originalRenderContents = cartDrawer?.renderContents;

    // Override renderContents to defer opening when we have bundle items to add
    if (cartDrawer && originalRenderContents) {
      cartDrawer.renderContents = function (parsedState) {
        // Store the cart data from the base product add
        if (!isProcessingBundle) {
          pendingCartData = parsedState;
        }

        // If we're processing bundle items, don't open yet - wait for bundle items to finish
        if (isProcessingBundle) {
          console.log(
            "Bundle Builder: Deferring drawer open until bundle items are added",
          );
          this.classList.remove("is-empty");
          return;
        }

        // No bundle items, proceed normally
        return originalRenderContents.call(this, parsedState);
      };
    }

    // Listen for cart update events using Dawn's pub/sub system
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      console.log("Bundle Builder: Cart update detected:", event);

      // Only proceed if this is from the product-form (base product add)
      if (event.source !== "product-form") {
        console.log("Bundle Builder: Event not from product-form, skipping");
        return;
      }

      // Collect bundle items with their quantities
      const bundleItems = [];
      const bundleElements = document.querySelectorAll(".gb-item");

      console.log(
        "Bundle Builder: Found " + bundleElements.length + " bundle items",
      );

      bundleElements.forEach((item) => {
        const variantId = parseInt(item.dataset.variantId);
        const qtySpan = item.querySelector(".gb-count");

        if (qtySpan) {
          const qty = parseInt(qtySpan.textContent);

          if (qty > 0) {
            bundleItems.push({
              id: variantId,
              quantity: qty,
            });
          }
        }
      });

      console.log("Bundle Builder: Bundle items to add:", bundleItems);

      // Only add if we have bundle items
      if (bundleItems.length > 0) {
        // Mark that we're processing bundle items
        isProcessingBundle = true;

        // Get the sections we need to render
        const sections = cartDrawer
          ? cartDrawer.getSectionsToRender().map((section) => section.id)
          : ["cart-drawer", "cart-icon-bubble"];

        console.log("Bundle Builder: Requesting sections:", sections);

        // Add bundle items WITH sections parameter so we get the updated HTML
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: bundleItems,
            sections: sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Bundle Builder: Bundle items added successfully:", data);

            // Now we have the updated cart state with sections
            // Reset flag so drawer can open
            isProcessingBundle = false;

            // Render the cart drawer with the updated cart data (includes all items)
            if (cartDrawer && data.sections) {
              // Use the original renderContents to open the drawer with fresh data
              originalRenderContents.call(cartDrawer, data);
            }
          })
          .catch((error) => {
            console.error("Bundle Builder: Error adding items:", error);
            isProcessingBundle = false;

            // If there's an error, still open the drawer with the base product
            if (cartDrawer && pendingCartData && originalRenderContents) {
              originalRenderContents.call(cartDrawer, pendingCartData);
            }
          });
      } else {
        console.log(
          "Bundle Builder: No bundle items selected, letting Dawn proceed normally",
        );
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBundleBuilder);
  } else {
    initBundleBuilder();
  }
})();
